import { Wand2Icon } from 'lucide-react';

import { Icon, Wrapper } from './rewardo_ai.styles';

type RewardoAiProps = {
  large?: boolean;
};

export default function RewardoAi({ large }: RewardoAiProps) {
  return (
    <Wrapper large={large}>
      <Icon>
        <Wand2Icon size={large ? 14 : 12} />
      </Icon>{' '}
      Rewardo AI
    </Wrapper>
  );
}
